export default __webpack_public_path__ + "static/pattern-black-c46ea3d9712affef37b05a3d5aaaf2f4.jpg";